import { atom } from 'recoil';
import { COMMON } from 'pages/provisioning/day2/github-onboarding-new/utils/constant';

export const orderId = atom({
    key: 'gh-new-orderId',
    default: undefined,
});

export const toggleSspModels = atom({
    key: 'gh-new-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isSubmitOrderSuccess: false,
        isSubmitConfirmationOpen: false,
        isCostSplitOpen: false,
        isReposToMigrateOpen: false,
        isUserManagementOpen: false,
        isAssignReposOpen: false,
        isGithubADMembersOpen: false,
        isGithubADMembersRemoveOpen: false,
        isMicroServiceConfigOpen: false,
        isSonarQubeOpen: false,
        isJfrogOpen: false,
        action: '',
    },
});

export const sspSubmitOrder = atom({
    key: 'gh-new-sspOrder',
    default: {
        appOwner: null,
        appOwnerDetails: null,
        applicationName: null,
        appShortName: null,
        adoProjectName: null,
        adoOrganization: null,
        applicationService: null,
        applicationServiceDetails: null,
        soxClassification: null,
        businessApplication: null,
        businessAppDetails: null,
        applicationSupportGroup: '',
        registeredInSnow: null,
        sandboxPocDetails: {
            reasonForNotRegistering: null,
            purposeOfUsingSandbox: null,
            etaForRegistrationInMonths: null,
        },
        onboardingType: 'Migrate',
        sector: null,
        sectorDetail: null,
        capability: null,
        capabilityDetails: null,
        cmpHCode: null,
        portfolio: null,
        isUsingAzureBoards: 'Yes',
        isMigratingADO: 'ADO',
        isMigratingADOPipelines: null,
        isMigratingArgoCD: null,
        isOnboardingPipelines: null,
        pipelineSetupType: null,
        isReaderTeamRequired: null,
        environment: null,
        githubOrgUnit: null,
        githubOrgUnitDetails: null,
        githubRepoName: '',
        githubRepo: null,
        githubRepoDetail: null,
        githubADGroupMember: null,
        githubADGroupMemberDetails: null,
        githubADGroupRemoveMember: null,
        githubADGroupRemoveMemberDetails: null,
        githubADGroupCWWMembers: [],
        githubADGroupCORPPVTMembers: [],
        githubADGroupCORPPVTHasServiceAccount: null,
        githubADGroupCORPPVTServiceAccounts: [],
        githubADGroupServiceAccount: null,
        removedGithubADGroupCWWMembers: [],
        removedGithubADGroupCORPPVTMembers: [],
        userAccessTeamMember: null,
        userAccessTeamMemberDetails: null,
        migrationConfirmation: false,
        microservicesConfigs: [
            {
                applicationType: null,
                templateLanguage: null,
                templateLanguageDetails: null,
                templateBuildTool: '',
                templateFrameWork: '',
                templateName: '',
                pipelineTemplateTechStack: null,
                applicationMicroserviceName: '',
                newgithubRepositoryName: '',
                codeRepositoryStack: '',
                isClone: false,
            },
        ],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },

            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: "GitHub license pricing is $13.71 per user per month. You'll only be charged for your primary team or group membership, so joining additional teams won't incur extra charges",
        },
        catalogCode: null,
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const validOnboardingForm = atom({
    key: 'gh-new-validOnboardingForm',
    default: {
        isDuplicateGithubADGroupMember: false,
        isGithubADGroupTrainingValid: false,
        isDuplicateGitHubAdMember: false,
        isMemberMissingEmail: false,
        isInvalidDomain: false,
        isNotValidGithubRepositoryName: false,
        isDuplicateRepositoryName: false,
        isDuplicateTeamMember: false,
        adGroupMemberMatchedBaseGroups: [],
        adGroupMemberMatchedCoPilotGroups: [],
        adGroupMemberApiMessage: '',
        isAdGroupMemberNotEligible: false,
        isAdGroupMemberEligibleWithCoPilot: false,
        isServiceAccountValid: false,
        isAdGroupServiceAccountValid: false,
        isDuplicateAdGroupServiceAccount: false,
        adGroupServiceAccountValidationError: '',
        isExistingArtifactoryNameValid: false,
        isDuplicateSonarMember: false,
        isSonarMemberTrainingValid: false,
        isSonarMemberLimitExceeded: false,
        isArtifactoryNameValid: false,
        isGitHubAccountMissing: false,
    },
});

export const isBudgetCodeValid = atom({
    key: 'gh-new-budget-code',
    default: false,
});

export const costEstimateState = atom({
    key: 'gh-new-costEstimateState',
    default: null,
});

export const isLoadingCostApiState = atom({
    key: 'gh-new-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const showPreviewOrder = atom({
    key: 'gh-new-show-previewOrder',
    default: null,
});

export const isValidappSupportMailId = atom({
    key: 'gh-new-isValidappSupportMailId',
    default: false,
});

export const teams = atom({
    key: 'gh-new-teams',
    default: [],
});

export const draftTeams = atom({
    key: 'gh-new-draftTeams',
    default: [],
});

export const isValidationLoading = atom({
    key: 'gh-new-isValidationLoading',
    default: false,
});

export const reposToMigrate = atom({
    key: 'gh-new-reposToMigrate',
    default: [],
});

export const fetchedAdoRepos = atom({
    key: 'gh-new-fetchedAdoRepos',
    default: [],
});

export const fetchedGithubRepos = atom({
    key: 'gh-new-fetchedGithubRepos',
    default: [],
});

export const isGithhubConfigFullFilled = atom({
    key: 'gh-new-github-ad-group',
    default: false,
});

export const isMigrateRepoConfigFullFilled = atom({
    key: 'gh-new-migrate-repo',
    default: false,
});

export const isUserAccessConfigFullFilled = atom({
    key: 'gh-new-user-config',
    default: false,
});

export const isAssignReposConfigFullFilled = atom({
    key: 'gh-new-assign-repo',
    default: false,
});

export const isMicroServiceConfigFullFilled = atom({
    key: 'gh-new-micro-service-config',
    default: false,
});

export const initializedTeamKey = atom({
    key: 'gh-new-team-initialize-key',
    default: '',
});

export const teamValidationCache = atom({
    key: 'gh-new-team-validation-cache',
    default: {},
});

export const isSonarQubeConfigFilled = atom({
    key: 'gh-new-sonarqube-config-filled',
    default: false,
});

export const isJfrogConfigFilled = atom({
    key: 'gh-new-jfrog-config-filled',
    default: false,
});

export const sonarQubeConfig = atom({
    key: 'gh-new-sonarqube-config',
    default: {
        requiresIntegration: null,
        validationData: null,
        serviceAccountsFromApi: [],
        shouldValidate: true,
        shouldModifyProjectName: COMMON.NO,
        modifiedSonarProjects: [],
        isSonarGroupServiceAccount: false,
        sonarGroupServiceAccount: null,
        sonarGroupServiceAccountValid: false,
        isServiceAccountExists: null,
        hasServiceAccount: null,
        serviceAccount: '',
        serviceAccountValidationError: null,
    },
});

export const jfrogConfig = atom({
    key: 'gh-new-jfrog-config',
    default: {
        requiresIntegration: null,
        dependencyRepoOption: null,
        hasArtifactoryName: null,
        projectOrganization: null,
        repoConfigurations: [],
        jfrogRepoTypes: [],
    },
});

export const isAppShortNameExist = atom({
    key: 'gh-new-isAppShortNameExist',
    default: false,
});

export const pipelineClassificationData = atom({
    key: 'gh-new-pipelineClassificationData',
    default: [],
});

export const argoCDConfigData = atom({
    key: 'gh-new-argoCDConfigData',
    default: [],
});

export const fetchedArgoCDRepos = atom({
    key: 'gh-new-fetchedArgoCDRepos',
    default: [],
});

export const variableGroupExtractionData = atom({
    key: 'gh-new-variableGroupExtractionData',
    default: [],
});

export const deploymentPatternValuesData = atom({
    key: 'gh-new-deploymentPatternValuesData',
    default: null,
});

export const newOnboardingPipelineTemplates = atom({
    key: 'gh-new-newOnboardingPipelineTemplates',
    default: [],
});

export const newOnboardingPipelineConfig = atom({
    key: 'gh-new-newOnboardingPipelineConfig',
    default: [],
});

export const newOnboardingPipelineEligible = atom({
    key: 'gh-new-newOnboardingPipelineEligible',
    default: null,
});
